
import React, { memo } from "react";
import { Button } from "@/components/ui/button";
import { Sparkles, Settings, Layers, Package } from "lucide-react";
import { cn } from "@/lib/utils";
import { NavigationMenuItem } from "@/components/ui/navigation-menu";
import { useAuth } from "@/hooks/auth/useAuth";

interface ProtectedNavLinksProps {
  isActive: (path: string) => boolean;
  handleNavigate: (path: string) => (e: React.MouseEvent) => void;
}

const ProtectedNavLinksComponent = ({
  isActive,
  handleNavigate
}: ProtectedNavLinksProps) => {
  const { effectiveIsAdmin } = useAuth();

  return (
    <>
      <NavigationMenuItem>
        <Button
          variant="ghost"
          className={cn(
            "flex items-center gap-2 text-yarn-slate font-medium hover:text-primary hover:bg-white/40",
            isActive('/pattern-generator') && "bg-white/50 text-primary"
          )}
          onClick={handleNavigate("/pattern-generator")}
          aria-label="Create new pattern"
        >
          <Sparkles className="h-4 w-4" />
          <span>Create</span>
        </Button>
      </NavigationMenuItem>

      <NavigationMenuItem>
        <Button
          variant="ghost"
          className={cn(
            "flex items-center gap-2 text-yarn-slate font-medium hover:text-primary hover:bg-white/40",
            isActive('/studio') && "bg-white/50 text-primary"
          )}
          onClick={handleNavigate("/studio")}
          aria-label="My Knits"
        >
          <Layers className="h-4 w-4" />
          <span>My Knits</span>
        </Button>
      </NavigationMenuItem>

      <NavigationMenuItem>
        <Button
          variant="ghost"
          className={cn(
            "flex items-center gap-2 text-yarn-slate font-medium hover:text-primary hover:bg-white/40",
            isActive('/shelf') && "bg-white/50 text-primary"
          )}
          onClick={handleNavigate("/shelf")}
          aria-label="My Stash"
        >
          <Package className="h-4 w-4" />
          <span>My Stash</span>
        </Button>
      </NavigationMenuItem>

      {effectiveIsAdmin && (
        <NavigationMenuItem>
          <Button
            variant="ghost"
            className={cn(
              "flex items-center gap-2 text-yarn-slate font-medium hover:text-primary hover:bg-white/40",
              isActive('/admin') && "bg-white/50 text-primary"
            )}
            onClick={handleNavigate("/admin")}
          >
            <Settings className="h-4 w-4" />
            <span>Admin</span>
          </Button>
        </NavigationMenuItem>
      )}
    </>
  );
};

ProtectedNavLinksComponent.displayName = 'ProtectedNavLinks';

export const ProtectedNavLinks = memo(ProtectedNavLinksComponent);
